import React from "react";
import "../Css/Accounts.css";
import {calculateByYear} from "../About/About";
import {Education} from "../types";

interface EducationSectionProps {
    education?: Education[],
}

export function EducationSection({education}:EducationSectionProps) {

    return (
        <section className="cv-section">
            <h2>Education</h2>
            <div className="cv-education">
                {education?.map((edu) => {
                        const yearRange = calculateByYear(edu);

                        return <div key={edu.title} className="cv-job">
                            {edu.link
                                ? <a href={edu.link} target="_blank" rel="noopener noreferrer">{edu.title}</a>
                                : <strong className="cv-job-title">{edu.title}</strong>}
                            <div className="cv-job-years">
                                <span className="year-range">{yearRange}</span>
                            </div>
                        </div>
                    }
                )}
            </div>
        </section>
    );
}
